module.exports = __webpack_public_path__ + "img/price.4f76da2f.png";